import React from 'react';

// Comps
import {ButtonWithChildren as Button} from '@arctheme-components/elements/Button/ButtonWithChildren';

type Props = {
  classes?: string;
  link?: string;
  // @ts-ignore
  onClick?: (event: React.ClickEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  children?: React.ReactNode;
  ariaLabel?: string;
  isLoading: boolean;
  loadingText?: string;
  spinnerType?: '' | 'light';
};

const ButtonSpinner = ({ ...props }: Props) => {
  const { children, isLoading, loadingText = '', spinnerType = '' } = props;

  return (
    <Button
      type='submit'
      {...props}
    >
      {isLoading ? (
        <>
          {loadingText && (
            <span
              className='button-spinner__text'
              dangerouslySetInnerHTML={{ __html: loadingText }}
            ></span>
          )}

          <span className='button-spinner__spinner scale-50'>
            <span className={`spinner spinner--${spinnerType}`}></span>
          </span>
        </>
      ) : (
        children
      )}
    </Button>
  );
};

export default ButtonSpinner;
